import { ConfigCommunaute } from './models/config';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { retry } from 'rxjs/operators';
import { ViewportScroller } from '@angular/common';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PageConfigService {

  defaultConfig = 'assets/json/homepage/default.json';

  private configSubject: BehaviorSubject<ConfigCommunaute>;
  public config: Observable<ConfigCommunaute>;

  private _themeName : string;
  private _themeList : [string];
  get theme() : string {
    return this._themeName;
  }
  public getConfig(url : string) {
    return this.http.get(url);
  }

  public changeTheme(id : number) {
    this._themeName = this._themeList[id];
  }


//get conf
public get configValue(): any {
  return this.configSubject.value;
}

 // get config  communauté
getConfigCom(url: string): Observable <ConfigCommunaute> {
  return this.http.get<any>(`${url}`).pipe(map(res => {
    // store jwt token in local storage 
    localStorage.setItem('config', JSON.stringify(res));
    this.configSubject.next(res);
    return res;
  }));
}

//   elementId
//   public onClick(elementId: string): void { 
//     console.log('bno '+elementId)
    
//     this.router.navigate(['/']);
//     this.viewportScroller.scrollToAnchor(this.elementId)
// }

  constructor(private http: HttpClient, private router: Router , private viewportScroller: ViewportScroller) { 

    this.configSubject = new BehaviorSubject<ConfigCommunaute>(JSON.parse(localStorage.getItem('config')));
    this.config = this.configSubject.asObservable();

  }
}
